// extracted by mini-css-extract-plugin
module.exports = {"navy100":"#F8FAFE","container":"QuotePreviewNotice_container__JU6es"};